import { useEffect, useState } from 'react';

import { EditOutlined, DeleteOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { Badge, Button, Col, Input, Popconfirm, Row, Switch, Tooltip, Typography } from 'antd';
import { useMessageLogger } from 'hooks/useMessageLogger';
import type { UserTracker } from 'models/user';
import { usersApi } from 'services/rtk/users';

import styles from './TrackerRow.module.css';

const { Text } = Typography;

interface TrackerRowProps {
  row: UserTracker;
  userId: number;
}

export const TrackerRow = ({ row, userId }: TrackerRowProps) => {
  const width = window.innerWidth;
  const [active, setActive] = useState(false);
  const [newToken, setNewToken] = useState('');
  const [deleteTracker, { error: deleteError, status: deleteStatus }] = usersApi.useDeleteTrackerMutation();
  const [updateToken, { error, status }] = usersApi.useUpdateUserTrackerMutation();
  const [canUpload, setCanUpload] = useState(row.permissions.canUpload);

  useEffect(() => {
    function closeByEscape(evt: KeyboardEvent) {
      if (evt.key === 'Escape') {
        setActive(false);
        setCanUpload(row.permissions.canUpload);
      }
    }
    if (active) {
      document.addEventListener('keydown', closeByEscape);
      return () => {
        document.removeEventListener('keydown', closeByEscape);
      };
    }
  }, [active, newToken, row, updateToken]);

  useMessageLogger({
    error: deleteError,
    status: deleteStatus,
    successMessage: 'Трекер удалён',
  });

  useMessageLogger({
    error,
    status,
    successMessage: 'Трекер обновлен',
  });

  return (
    <Row>
      {width >= 600 && (
        <Col span={12} className={styles.keitaro}>
          <Text strong>{`Keitaro(${row.url})`}:</Text>
        </Col>
      )}
      <div className={active ? `${styles.columns} ${styles.columns_active}` : styles.columns}>
        <div className={styles.leftSide}>
          {width < 600 && (
            <Col span={12} className={styles.keitaro}>
              <Text strong>{`Keitaro(${row.url})`}:</Text>
            </Col>
          )}
          <Col
            style={
              active
                ? { display: 'flex', columnGap: '10px', alignItems: 'center' }
                : { display: 'flex', columnGap: '10px' }
            }
          >
            {!active && <Badge color={canUpload ? 'green' : 'red'} className={styles.badge} />}
            {active && width > 600 && (
              <div className={styles.newToken}>
                <Input.Password
                  value={newToken}
                  placeholder="Введите новый токен"
                  onChange={(e) => setNewToken(e.currentTarget.value)}
                />
                <CloseOutlined
                  className={styles.cross}
                  onClick={() => {
                    setActive(false);
                    setCanUpload(row.permissions.canUpload);
                  }}
                />
              </div>
            )}
            {!active && (
              <Text style={{ whiteSpace: 'pre-line' }}>
                <Typography.Paragraph style={{ marginBottom: '0' }} copyable={{ text: row.token }}>
                  ••••••••••••••••••
                </Typography.Paragraph>
              </Text>
            )}
          </Col>
        </div>
        <Col className={active ? `${styles.buttons} ${styles.buttons_active}` : styles.buttons}>
          {active && (
            <div className={styles.switch}>
              {active && width < 600 && (
                <div className={styles.newToken}>
                  <Input.Password
                    value={newToken}
                    placeholder="Введите новый токен"
                    onChange={(e) => setNewToken(e.currentTarget.value)}
                  />
                  <CloseOutlined
                    className={styles.cross}
                    onClick={() => {
                      setActive(false);
                      setCanUpload(row.permissions.canUpload);
                    }}
                  />
                </div>
              )}
              <div className={styles.mobileEdit}>
                <Badge color={canUpload ? 'green' : 'red'} className={styles.badge} />
                <Switch
                  defaultChecked={canUpload}
                  onChange={() => {
                    setCanUpload(!canUpload);
                  }}
                />
              </div>
            </div>
          )}
          <div className={styles.success}>
            {active ? (
              <Button
                icon={<CheckOutlined />}
                onClick={() => {
                  if (newToken.length > 0) {
                    updateToken({
                      id: userId,
                      trackerID: row.id.toString(),
                      token: newToken,
                      permissions: {
                        canUpload: canUpload,
                      },
                    });
                  } else {
                    updateToken({
                      id: userId,
                      trackerID: row.id.toString(),
                      permissions: {
                        canUpload: canUpload,
                      },
                    });
                  }
                  setActive(false);
                  setNewToken('');
                }}
              />
            ) : (
              <Tooltip style={{ padding: '8px' }} title={'Редактировать'} mouseEnterDelay={0.4}>
                <Button
                  icon={<EditOutlined />}
                  onClick={() => {
                    setActive(true);
                  }}
                />
              </Tooltip>
            )}
            <Popconfirm
              placement="topLeft"
              title="Вы уверены, что хотите удалить домен?"
              onConfirm={() => {
                deleteTracker({ id: userId, trackerID: row.id });
                setActive(false);
              }}
              okText="Да"
              cancelText="Нет"
            >
              <Button danger icon={<DeleteOutlined />} />
            </Popconfirm>
          </div>
        </Col>
      </div>
    </Row>
  );
};

// eslint-disable-next-line no-lone-blocks
{
  // Новая вёрстка для редактирования доменов
  /* <Col span={16}>
        <Input.Group compact style={{ width: "100%" }}>
          {svgActive ? (
            <CheckCircleOutlined
              onClick={() => setSvgActive(false)}
              style={{ color: "#52c41a", marginRight: "0px" }}
              className={styles.svg}
            />
          ) : (
            <CloseCircleOutlined
              onClick={() => setSvgActive(true)}
              style={{ color: "#ff4d4f", marginRight: "0px" }}
              className={styles.svg}
            />
          )}
          <Input.Password style={{ width: "calc(100% - 100px)" }} placeholder="Введите токен" />
          <Button icon={<CheckOutlined />} style={{ marginRight: "0px" }} />
          <Button icon={<DeleteOutlined />} danger />
        </Input.Group>
      </Col> */
}
